<template>
  <div class="modal fade" id="gpx-import-choice-dialog" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Import File</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p class="mb-3">
            This file contains a route and {{ waypointCount }} waypoint{{ waypointCount === 1 ? '' : 's' }}.
            What would you like to import?
          </p>

          <div class="choice-options">
            <div class="choice-card" :class="{ selected: selectedChoice === 'route' }" @click="selectedChoice = 'route'">
              <div class="choice-icon">
                <span class="material-icons">route</span>
              </div>
              <h6>Route Only</h6>
              <p class="small text-muted">Import the track, skip the waypoints.</p>
            </div>

            <div class="choice-card" :class="{ selected: selectedChoice === 'waypoints' }" @click="selectedChoice = 'waypoints'">
              <div class="choice-icon">
                <span class="material-icons">place</span>
              </div>
              <h6>Waypoints Only</h6>
              <p class="small text-muted">Add the waypoints as hike highlights, skip the route.</p>
            </div>

            <div class="choice-card" :class="{ selected: selectedChoice === 'both' }" @click="selectedChoice = 'both'">
              <div class="choice-icon">
                <span class="material-icons">done_all</span>
              </div>
              <h6>Both</h6>
              <p class="small text-muted">Import the route and add the waypoints as hike highlights.</p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" @click="confirm" :disabled="!selectedChoice">
            Import
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { Modal } from 'bootstrap';

export default defineComponent({
  data() {
    return {
      selectedChoice: null,
      waypointCount: 0,
      modal: null,
      resolvePrompt: null,
    };
  },
  mounted() {
    this.modal = new Modal(this.$el);
    // Covers every dismissal path (Cancel button, close icon, backdrop click, ESC)
    // as well as the explicit Import click, which hides the modal itself.
    this.$el.addEventListener('hidden.bs.modal', () => {
      if (this.resolvePrompt) {
        const resolve = this.resolvePrompt;
        this.resolvePrompt = null;
        resolve(null);
      }
    });
  },
  methods: {
    prompt(waypointCount) {
      this.waypointCount = waypointCount;
      this.selectedChoice = null;
      this.modal.show();
      return new Promise((resolve) => {
        this.resolvePrompt = resolve;
      });
    },
    confirm() {
      if (!this.selectedChoice) {
        return;
      }
      const choice = this.selectedChoice;
      const resolve = this.resolvePrompt;
      this.resolvePrompt = null;
      this.modal.hide();
      if (resolve) {
        resolve(choice);
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.choice-options {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.choice-card {
  flex: 1 1 30%;
  min-width: 140px;
  padding: 1.25rem 1rem;
  border: 2px solid var(--gray);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;

  &:hover {
    border-color: #fddf00;
    background-color: var(--gray);
  }

  &.selected {
    border-color: #fddf00;
    background-color: var(--gray);
  }

  .choice-icon {
    margin-bottom: 0.5rem;

    .material-icons {
      font-size: 1.75rem;
      color: #fff;
    }
  }

  h6 {
    margin-bottom: 0.5rem;
    font-weight: 600;
  }

  p {
    margin: 0;
  }
}
</style>
